import { connect } from 'react-redux';

import { Dropdown } from 'bricks/Dropdown';
import { setBrandAndFetchModels } from 'store/widgets/TradeInNewCalculator/brand/actions';
import {
  selectTradeInBrandIsDisabled,
  selectTradeInBrandIsError,
  selectTradeInBrandListForSelect,
  selectTradeInBrandSelectedValue,
  selectTradeInBrandTitle,
} from 'store/widgets/TradeInNewCalculator/brand/selectors';

import {
  DispatchPropsSelect,
  StatePropsSelect,
} from './types';

const mapStateToProps = (state): StatePropsSelect => ({
  title: selectTradeInBrandTitle(state),
  value: selectTradeInBrandSelectedValue(state),
  options: selectTradeInBrandListForSelect(state),
  disabled: selectTradeInBrandIsDisabled(state),
  error: {
    isError: selectTradeInBrandIsError(state),
    message: '',
  },
});

const mapDispatchToProps = (dispatch): DispatchPropsSelect => ({
  onChange: (brand) => {
    dispatch(setBrandAndFetchModels(brand));
  },
});

export const BrandSelect = connect(mapStateToProps, mapDispatchToProps)(Dropdown);
